export default function HomeFiveAbout(){
    return(
        <section id="about" class="about-us-area pt-140 pb-75 pt-md-60 pb-md-30 pt-xs-60 pb-xs-75 home-5">
			<div class="container">
				<div class="row align-items-center">
					<div class="col-lg-6">
						<div class="about-img-wrapper mb-30">
							<img class="img-one img-fluid d-xxl-inline-block" src="assets/img/home-5/h4-service.webp" alt="About Img" />
							<div class="experience-box">
								<div class="count-text2 text-center mb-50">
									<h3><span class="counter">1234</span>
										<span class="prefix">+</span>
									</h3>
									<span class="title"> Worldwide Our Clients</span>
								</div>
							</div>
						</div>
					</div>
					<div class="col-lg-6">
						<div class="about-text-wrapper2 mb-30">
							<h6 class="semi-title">About Company</h6>
							<h2 class="sect-title mb-35">Bringing New IT Business Solutions</h2>
							<ul class="text-list list-none">
								<li>
									<div class="services-list">
										<div class="services-icon">
											<i class="fas fa-search"></i>
										</div>
										<div class="services-text">
											<h5 class="fs-20">SEO Worldwide</h5>
											<p>Automotive has sought to change the way customers think about
												auto service by providing knowledgeable</p>
										</div>
									</div>
								</li>
								<li>
									<div class="services-list">
										<div class="services-icon">
											<i class="fas fa-rocket"></i>
										</div>
										<div class="services-text">
											<h5 class="fs-20">Search Engine Optimization</h5>
											<p>Automotive has sought to change the way customers think about
												auto service by providing knowledgeable</p>
										</div>
									</div>
								</li>
								<li>
									<div class="services-list">
										<div class="services-icon">
											<i class="fas fa-bell"></i>
										</div>
										<div class="services-text">
											<h5 class="fs-20">Instant Support</h5>
											<p>Automotive has sought to change the way customers think about
												auto service by providing knowledgeable</p>
										</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</section>
    )
}